/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

// eslint-disable-next-line camelcase
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<dom-module id="cs-pause-animation-styles">
<template>
  <style>
    /** * OverWrite animation keyframe */
    @keyframes slideUpFadeIn {
      from {
        opacity: var(--cs-fade-in-from-value);
        transform: translate(0, var(--cs-pause-animation-slide-up-from-value));
      }

      to {
        opacity: var(--cs-fade-in-to-value);
        transform: translate(0, var(--cs-pause-animation-slide-up-to-value));
      }
    }

    @keyframes slideDownFadeIn {
      from {
        opacity: var(--cs-fade-in-from-value);
        transform: translate(0, var(--cs-pause-animation-slide-down-from-value));
      }

      to {
        opacity: var(--cs-fade-in-to-value);
        transform: translate(0, var(--cs-pause-animation-slide-down-to-value));
      }
    }

    @keyframes slideInLeftFadeIn {
      from {
        opacity: var(--cs-fade-in-from-value);
        transform: translate(var(--cs-pause-animation-slide-in-left-from-value), 0);
      }

      to {
        opacity: var(--cs-fade-in-to-value);
        transform: translate(var(--cs-pause-animation-slide-in-left-to-value), 0);
      }
    }

    @keyframes slideInRightFadeIn {
      from {
        opacity: var(--cs-fade-in-from-value);
        transform: translate(var(--cs-pause-animation-slide-in-right-from-value), 0);
      }

      to {
        opacity: var(--cs-fade-in-to-value);
        transform: translate(var(--cs-pause-animation-slide-in-right-to-value), 0);
      }
    }

    @keyframes slideOutDownFadeOut {
      from {
        opacity: var(--cs-fade-out-from-value);
        transform: translate(0, var(--cs-pause-animation-slide-out-down-from-value));
      }

      to {
        opacity: var(--cs-fade-out-to-value);
        transform: translate(0, var(--cs-pause-animation-slide-out-down-to-value));
      }
    }

    @keyframes slideOutUpFadeOut {
      from {
        opacity: var(--cs-fade-out-from-value);
        transform: translate(0, var(--cs-pause-animation-slide-out-up-from-value));
      }

      to {
        opacity: var(--cs-fade-out-to-value);
        transform: translate(0, var(--cs-pause-animation-slide-out-up-to-value));
      }
    }

    @keyframes slideOutLeftFadeOut {
      from {
        opacity: var(--cs-fade-out-from-value);
        transform: translate(var(--cs-pause-animation-slide-out-left-from-value), 0);
      }

      to {
        opacity: var(--cs-fade-out-to-value);
        transform: translate(var(--cs-pause-animation-slide-out-left-to-value), 0);
      }
    }

    @keyframes slideOutRightFadeOut {
      from {
        opacity: var(--cs-fade-out-from-value);
        transform: translate(var(--cs-pause-animation-slide-out-right-from-value), 0);
      }

      to {
        opacity: var(--cs-fade-out-to-value);
        transform: translate(var(--cs-pause-animation-slide-out-right-to-value), 0);
      }
    }
  </style>
</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);

// WEBPACK FOOTER //
// ./src/styles/TextFieldCatalog.scss
